import {
    CorporationTimeRangesRequest,
    ICorporationTimeRangesRequest,
} from '@kcftech/prometheus-client';
import { useMutation } from '@tanstack/react-query';
import { sdClient } from 'contexts/SDKClientContext';
import { queryClient } from 'utils/query';

export type CorporationTimeRangeMutationRequest = {
    corporationId: string;
    body: ICorporationTimeRangesRequest;
};
export function updateCorporationTimeRange({
    corporationId,
    body,
}: CorporationTimeRangeMutationRequest) {
    return sdClient.setCorporationTimeRanges({
        corporationId,
        body: new CorporationTimeRangesRequest(body),
    });
}

export type UseUpdateCorporationTimeRangeOptions = Readonly<{
    queryName: string;
}>;

export function useUpdateCorporationTimeRange({
    queryName,
}: UseUpdateCorporationTimeRangeOptions) {
    return useMutation({
        mutationFn: updateCorporationTimeRange,

        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: [queryName],
            });
        },
    });
}
